var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccesblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 801,
    height: 801,
    viewBox: "0 0 801 801",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 800,
    height: 800,
    rx: 400,
    fill: "url(#paint0_linear_1_83)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M587.167 272.167L330.5 528.833L213.834 412.167",
    stroke: "white",
    strokeWidth: 72.3232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_83",
    x1: -0.499998,
    y1: 0.0000292197,
    x2: 801.5,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#236BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14479B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesblue);
export default __webpack_public_path__ + "static/media/succesblue.e34b45d851139ab525ed4320d7ff21c7.svg";
export { ForwardRef as ReactComponent };